import { useState, useRef, useEffect } from 'react'
import {
    Flex, Image, VStack, HStack, Text, Button, Link, Icon, SimpleGrid,
    Heading, SlideFade, Divider,Stack,
    useColorModeValue as colorValue
} from '@chakra-ui/react'
import { BsCardImage, BsJustifyLeft, BsBuilding } from "react-icons/bs";

import buildingData from '../../assets/data/building.json'

const ItemLabel = ({ title, detail }) => {
    return (
        <HStack spacing={2}>
            <Text fontSize="sm"><Text fontWeight="bold" as="span" mr={3}>{title}</Text>
                {detail}</Text>
        </HStack>
    )
}

const BuildingItem = ({ data, ...rest }) => {
    return (
        <Flex direction="column" {...rest} bgColor={colorValue("whiteAlpha.800", "blackAlpha.400")} borderRadius="xl" shadow="base" _hover={{
            shadow:"lg"
        }}>
            <Flex w="full" p={2}>
                <Image src={data.thumbnail} borderRadius="md" shadow="md"></Image>
            </Flex>
            <VStack align="start" p={8} minH="210px">
                <ItemLabel title="ชื่อ" detail={data.name} />
                <ItemLabel title="ที่อยู่" detail={data.adrress} />
                <ItemLabel title="ขนาด" detail={data.size} />
            </VStack>
            <Divider />
            <Stack spacing={4} justify="center" align="center"   p={4} direction={{base:"column",xl:"row"}}>
                {
                    data.gallery &&
                    <Link isExternal href={data.gallery} w="full">
                        <Button leftIcon={<Icon as={BsCardImage} />} size="sm" w="full" colorScheme="green">อัลบัมรูปภาพ</Button>
                    </Link>
                }
                {
                    data.link &&
                    <Link isExternal href={data.link} w="full">
                        <Button leftIcon={<Icon as={BsJustifyLeft} />} size="sm" w="full" colorScheme="yellow">อ่านเพิ่มเติม</Button>
                    </Link>
                }
            </Stack>
        </Flex>
    )
}

const BuildingList = () => {
    const [showPanel, setShowPanel] = useState(false)
    const sectionRef = useRef(null)

    const onScroll = () => {
        const ratio = window.scrollY / window.innerHeight
        setShowPanel(ratio >= 0.38)
    }

    useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => {
            window.removeEventListener('scroll', onScroll)
        }
    }, [])

    return (
        <section id="building_info" ref={sectionRef}>
            <Flex direction="column" p={{base:4,md:10}} mt={10} h={{ lg: "100vh" }} justify="center">
                <Flex justify="center" w="full" mb={10}>
                    <Heading textAlign="center"><Icon as={BsBuilding} mr={2} />อาคารที่พักข้าราชการศาลยุติธรรม (ในเขตกรุงเทพฯ)</Heading>
                </Flex>

                <SimpleGrid columns={{base:1, md: 2, lg: 4}} spacing={{base:2, md: 6}} w="full" >
                    {
                        buildingData && buildingData.map((item, i) => (
                            <SlideFade in={showPanel} offsetY={150} delay={0.18 * i} unmountOnExit={false} key={i} >
                                <BuildingItem data={item} />
                            </SlideFade>
                        ))
                    }
                </SimpleGrid>
            </Flex>
        </section>
    )
}

export default BuildingList
